import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
import DateRangePicker from '../../../customlib/DateRangePicker';
import DateRangePickerRich from '../../../customlib/DateRangePickerRich';
class DataPendingLeadsParcelMobile extends Component {
    state = {

     } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Leads Parcel"} showBackButton={true} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <Box sx={{fontWeight: "bold"}}>
                            Tanggal Leads
                        </Box>
                        <DateRangePicker onDateChanged={this.props.handleDateChanged} />
                        {/* <TextField
                            onChange={this.props.handleKeyword}
                            label="sales / customer / nomor wa / kategori"
                            type="text"
                            className="form-control"
                            id="namacustomer"
                            variant="outlined"
                            onKeyDown={this.props.onKeyDownHandler}
                            onBlur={() => {
                                
                            }}
                            size='small'
                            fullWidth
                        /> */}
                    </Filter>
                    {
                    this.props.state?.listMycustomer?.map((lead, index) => {
                        console.log("FUHARIAN", lead);
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">{lead.fromName}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {/* {Array.isArray(lead.fuData) ? lead.fuData.length : 0} FU */}
                                            Last FU
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography component="span">{lead.from}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {lead.lastFuDate ? Global.formatDateTimeToStrDate(lead.lastFuDate) : "Belum di FU"}
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Kategori</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {lead.productCategory}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Hasil FU</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.lastFuResultTmp}
                                                {lead.isEditing && (
                                                    <FormControl size='small' variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                                                        <InputLabel id="demo-simple-select-outlined-label">Hasil Follow Up</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            value={lead?.lastFuResultTmp === undefined | lead?.lastFuResultTmp === null ? "" : lead?.lastFuResultTmp}
                                                            onChange={(event) => this.props.handleHasilFuChangeMobile(event, lead)}
                                                            label="Hasil Follow Up"
                                                        >
                                                            {
                                                            Global.getListHasilFu().map(
                                                                (cat) => {
                                                                return (<MenuItem key={cat} value={cat}>{cat}</MenuItem>);
                                                                } 
                                                            )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Jumlah FU</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.countFuTmp}
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl size='small' variant="outlined" style={{width: '100%', marginTop: 15}}>
                                                                <InputLabel id="demo-simple-select-outlined-label">Jumlah FU</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="jumlahFu"
                                                                    value={lead?.countFuTmp !== undefined && lead?.countFuTmp !== null ? lead?.countFuTmp : 0}
                                                                    onChange={(event) => this.props.handleJumlahFuChangeMobile(event, lead)}
                                                                    label="Jumlah FU"
                                                                >
                                                                    {
                                                                        [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map(
                                                                            (jumlahFu) => {
                                                                                return (<MenuItem key={jumlahFu} value={jumlahFu}>{jumlahFu}</MenuItem>);
                                                                            } 
                                                                        )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )
                                                }
                                                
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} sx={{mt: "10px"}}>
                                            <Grid item xs={6}>
                                                {
                                                    !lead.isEditing && (
                                                        <Button onClick={() => this.props.toggleStartEditFu(lead)} fullWidth variant='contained' color='secondary'>
                                                        {/* <Button onClick={() => this.props.handleShowEditAnalisa(lead)} fullWidth variant='contained' color='secondary'> */}
                                                            Input FU
                                                        </Button>
                                                    )
                                                }

                                                {
                                                    lead.isEditing && (
                                                        <Button disabled={this.props.state.savingAnalisa} onClick={() => this.props.saveAnalisa(lead)} fullWidth variant='contained' color='error'>
                                                            Submit
                                                        </Button>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {
                                                    !lead.isEditing && (
                                                        <Button fullWidth variant='contained' color='error'>Buka Chat</Button>
                                                    )
                                                }

                                                {
                                                    lead.isEditing && (
                                                        <Button onClick={() => this.props.toggleStartEditFu(lead)} fullWidth variant='contained' color='warning'>
                                                            Batal
                                                        </Button>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </AccordionDetails>
                            </Accordion>
                            // <Box elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${index}`}>
                            //     <Grid container spacing={1}>
                            //         <Grid item xs={12}>
                            //             <Typography component="span">{lead.fromName}</Typography>
                            //         </Grid>
                            //         <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                            //             {Global.maskPhoneNumber(lead.from)}
                            //         </Grid>
                            //         <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                            //             {Global.formatDateTimeToStrDateTime24(lead.created_at)}
                            //         </Grid>
                            //     </Grid>
                            //     <Divider />
                            // </Box>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default DataPendingLeadsParcelMobile;